var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    {
      attrs: {
        visible: true,
        visible: "",
        showFooter: false,
        title: _vm.title,
        id: "test",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "my-15",
        },
        [
          _vm.type === "speed"
            ? _c("maximise-speed")
            : [
                _c("kp-list", { attrs: { data: _vm.KPcontactList } }),
                _c("concat-item", {
                  staticClass: "mt-15",
                  attrs: { data: _vm.contactList },
                }),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }